export default __webpack_public_path__ + "static/media/muse_background.5bbf4dda.png";